import React, { useEffect, useState } from 'react';

import { Banner, Header, Eventos, Casa, Buffet, Footer, Estacionamento, Contato } from '../../Componentes';

import Load from '../../Componentes/Load';
import * as S from './estilos';
import { Oval } from 'react-loader-spinner';

import ImgBanner from '../../Images/Banner.jpg';
import ImgBannerResp from '../../Images/BannerResp.jpg';
import 'react-confirm-alert/src/react-confirm-alert.css';

function Teste(props: any) {
  return <>xxx</>;
}

export default Teste;
